module.exports = __webpack_public_path__ + "img/star-green.f4c1bfb4.svg";